module.exports = __webpack_public_path__ + "static/media/bg_refer_friend.57aed575.png";